import gql from 'graphql-tag'

export const UPDATE_PHONE_RESOURCE = gql`
    mutation updatePhoneResource($input: PhoneResourceInput!) {
        updatePhoneResource(input: $input)
    }
`
